import { useEffect, useState } from 'react';
import {
  CardContent,
  Grid,
  Typography,
  Box,
  Button,
  Stack,
  TextField,
  FormControlLabel,
  Checkbox
} from '@mui/material';

// components
import BlankCard from '../../shared/BlankCard';
import CustomFormLabel from '../../forms/theme-elements/CustomFormLabel';
// import CustomSelect from '../../forms/theme-elements/CustomSelect';

// images
import { useSelector } from 'react-redux';
import { AppState } from 'src/store/Store';
import { useForm } from 'react-hook-form';
import { useUpdUserDataMutation } from 'src/redux/api/cabinet';
import { useDispatch } from 'react-redux';
import { updProfileData } from 'src/redux/slices/app';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UpdatePasswordBlock } from './UpdatePasswordBlock';
import { UpdateAvatar } from './UpdateAvatar';
import { Alerting } from 'src/views/components_cabinet/Alerting';

const AccountTab = () => {
  const { data } = useSelector((state: AppState) => state.app);
  const dispatch = useDispatch();
  const [getAlert, setgetAlert] = useState<{ type: number, msg: string } | undefined>(undefined);

  // Локальное состояние для чекбоксов
  const [telegramNoAccount, setTelegramNoAccount] = useState(false);
  const [vkNoAccount, setVkNoAccount] = useState(false);
  const [whatsappNoAccount, setWhatsappNoAccount] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: '',
      last_name: '',
      country: '',
      city: '',
      phone: '',
      telegram: '',
      vk: '',
      whatsapp: ''
    }
  });

  // Отслеживаем состояние чекбоксов через локальное состояние
  // const telegramNoAccount = watch('telegramNoAccount');
  // const vkNoAccount = watch('vkNoAccount');
  // const whatsappNoAccount = watch('whatsappNoAccount');

  const onSubmit = (data: any) => {
    // Данные уже подготовлены правильно, просто удаляем поля чекбоксов
    const processedData = { ...data };

    delete processedData.telegramNoAccount;
    delete processedData.vkNoAccount;
    delete processedData.whatsappNoAccount;

    userUpdateRequest(processedData);
  }

  const [userUpdateData, { isLoading: loadUpdateData }] = useUpdUserDataMutation();
  const userUpdateRequest = async (body: any) => {
    const jwt = localStorage.getItem('jwt');
    await userUpdateData({ body, jwt })
      .unwrap()
      .then((payload: any) => {
        dispatch(updProfileData(payload.data));
        setgetAlert({ type: 1, msg: payload.message });
      })
      .catch((error: any) => {
        setgetAlert({ type: 2, msg: error.data.message });
      })
  }

  useEffect(() => {
    if (data) {
      // Подготавливаем объект с данными для формы
      const formData = {
        first_name: data.first_name || '',
        last_name: data.last_name || '',
        country: data.country || '',
        city: data.city || '',
        phone: data.phone || '',
        // Telegram
        telegramNoAccount: data.telegram === '-',
        telegram: data.telegram === '-' ? '-' : (data.telegram || ''),
        // VK
        vkNoAccount: data.vk === '-',
        vk: data.vk === '-' ? '-' : (data.vk || ''),
        // WhatsApp
        whatsappNoAccount: data.whatsapp === '-',
        whatsapp: data.whatsapp === '-' ? '-' : (data.whatsapp || '')
      };

      // Сбрасываем форму с новыми данными
      reset(formData);
    }
  }, [data, reset]);

  // Обработчики изменения чекбоксов
  const handleTelegramCheckboxChange = (checked: boolean) => {
    setTelegramNoAccount(checked);
    if (checked) {
      setValue('telegram', '-');
    } else {
      setValue('telegram', '');
    }
  };

  const handleVkCheckboxChange = (checked: boolean) => {
    setVkNoAccount(checked);
    if (checked) {
      setValue('vk', '-');
    } else {
      setValue('vk', '');
    }
  };

  const handleWhatsappCheckboxChange = (checked: boolean) => {
    setWhatsappNoAccount(checked);
    if (checked) {
      setValue('whatsapp', '-');
    } else {
      setValue('whatsapp', '');
    }
  };

  const value = watch();

  return (
    <>
      {getAlert && <Alerting get={getAlert} />}
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <BlankCard>
            <CardContent>
              <Typography variant="h5" mb={1}>
                Редактировать профиль {data && data.login ? data.login : ''}
              </Typography>
              <Typography color="textSecondary" mb={3}>Измените фотографию своего профиля здесь</Typography>
              <Box textAlign="center" display="flex" justifyContent="center">
                <UpdateAvatar />
              </Box>
            </CardContent>
          </BlankCard>
        </Grid>
        {/*  Change Password */}
        <Grid item xs={12} lg={6}>
          <UpdatePasswordBlock />
        </Grid>

        <Grid item xs={12}>
          <BlankCard>
            <CardContent>
              <Typography variant="h5" mb={1}>
                Данные профиля
              </Typography>
              <Typography color="textSecondary" mb={3}>
                Изменить свои личные данные можно здесь
              </Typography>
              <form onSubmit={handleSubmit((data) => onSubmit(data))}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{
                        mt: 0,
                      }}
                      htmlFor="text-name"
                    >
                      Ваше имя
                    </CustomFormLabel>
                    <TextField
                      variant="outlined"
                      fullWidth
                      error={errors.first_name ? true : false}
                      helperText={errors.first_name ? `${errors.first_name.message}` : ``}
                      {...register("first_name", {
                        required: { value: true, message: "Поле имя обязательно для заполнения" },
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{
                        mt: 0,
                      }}
                      htmlFor="text-store-name"
                    >
                      Ваша фамилия
                    </CustomFormLabel>
                    <TextField
                      variant="outlined"
                      fullWidth
                      error={errors.last_name ? true : false}
                      helperText={errors.last_name ? `${errors.last_name.message}` : ``}
                      {...register("last_name", {
                        required: { value: true, message: "Поле фамилия обязательно для заполнения" },
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{
                        mt: 0,
                      }}
                      htmlFor="text-address"
                    >
                      Страна
                    </CustomFormLabel>
                    <TextField
                      variant="outlined"
                      fullWidth
                      error={errors.country ? true : false}
                      helperText={errors.country ? `${errors.country.message}` : ``}
                      {...register("country", {
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{
                        mt: 0,
                      }}
                      htmlFor="text-address"
                    >
                      Город
                    </CustomFormLabel>
                    <TextField
                      variant="outlined"
                      fullWidth
                      error={errors.city ? true : false}
                      helperText={errors.city ? `${errors.city.message}` : ``}
                      {...register("city", {
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{
                        mt: 0,
                      }}
                      htmlFor="text-email"
                    >
                      Email
                    </CustomFormLabel>
                    <TextField
                      value={data && data.email}
                      variant="outlined"
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{
                        mt: 0,
                      }}
                      htmlFor="text-phone"
                    >
                      Телефон
                    </CustomFormLabel>
                    <TextField
                      variant="outlined"
                      fullWidth
                      label="Номер телефона"
                      placeholder="+79991234567"
                      error={!!errors.phone}
                      {...register("phone", {
                        required: "Введите номер телефона",
                        pattern: {
                          value: /^\+?\d{10,15}$/,
                          message: "Некорректный номер. Пример: +79991234567",
                        },
                      })}
                    />
                    {errors.phone?.message && (
                      <Typography variant="caption" color="error">
                        {`${errors.phone.message}`}
                      </Typography>
                    )}
                  </Grid>

                  {/* Telegram */}
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{
                        mt: 0,
                      }}
                      htmlFor="text-telegram"
                    >
                      Ссылка на вас в Телеграм
                    </CustomFormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value.telegram === '-'}
                          onChange={(e) => handleTelegramCheckboxChange(e.target.checked)}
                        />
                      }
                      label="У меня нет Telegram"
                      sx={{ mb: 1 }}
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      label="Telegram"
                      placeholder="https://t.me/username"
                      disabled={telegramNoAccount}
                      error={!!errors.telegram}
                      {...register("telegram", {
                        validate: value => {
                          // Если значение равно "-" (выбран чекбокс) - валидация проходит
                          if (value === '-') return true;

                          // Если поле пустое - ошибка
                          if (!value || value.trim() === '') {
                            return "Введите ссылку на Telegram или отметьте чекбокс";
                          }

                          // Проверяем корректность ссылки
                          const pattern = /^https:\/\/t\.me\/([a-zA-Z0-9_]{5,32}|\+?[a-zA-Z0-9_-]{10,50})$/;
                          return (
                            pattern.test(value) ||
                            "Некорректная ссылка. Пример: https://t.me/username"
                          );
                        }
                      })}
                    />
                    {errors.telegram?.message && (
                      <Typography variant="caption" color="error">
                        {`${errors.telegram.message}`}
                      </Typography>
                    )}
                  </Grid>

                  {/* VK */}
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{
                        mt: 0,
                      }}
                      htmlFor="text-vk"
                    >
                      Ссылка на вас в VK
                    </CustomFormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value.vk === '-'}
                          onChange={(e) => handleVkCheckboxChange(e.target.checked)}
                        />
                      }
                      label="У меня нет VK"
                      sx={{ mb: 1 }}
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      label="VK"
                      placeholder="https://vk.com/username"
                      disabled={vkNoAccount}
                      error={!!errors.vk}
                      {...register("vk", {
                        validate: value => {
                          // Если значение равно "-" (выбран чекбокс) - валидация проходит
                          if (value === '-') return true;

                          // Если поле пустое - ошибка
                          if (!value || value.trim() === '') {
                            return "Введите ссылку на VK или отметьте чекбокс";
                          }

                          // Проверяем корректность ссылки
                          const pattern = /^https:\/\/vk\.com\/(id\d{1,15}|club\d{1,15}|public\d{1,15}|[a-zA-Z0-9_.]{3,32})$/;
                          return (
                            pattern.test(value) ||
                            "Некорректная ссылка. Пример: https://vk.com/id123456789"
                          );
                        }
                      })}
                    />
                    {errors.vk?.message && (
                      <Typography variant="caption" color="error">
                        {`${errors.vk.message}`}
                      </Typography>
                    )}
                  </Grid>

                  {/* WhatsApp */}
                  <Grid item xs={12} sm={6}>
                    <CustomFormLabel
                      sx={{ mt: 0 }}
                      htmlFor="text-whatsapp"
                    >
                      Ссылка на вас в WhatsApp
                    </CustomFormLabel>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={value.whatsapp === '-'}
                          onChange={(e) => handleWhatsappCheckboxChange(e.target.checked)}
                        />
                      }
                      label="У меня нет WhatsApp"
                      sx={{ mb: 1 }}
                    />
                    <TextField
                      variant="outlined"
                      fullWidth
                      label="WhatsApp"
                      placeholder="https://wa.me/79991234567"
                      disabled={whatsappNoAccount}
                      error={!!errors.whatsapp}
                      {...register("whatsapp", {
                        validate: value => {
                          // Если значение равно "-" (выбран чекбокс) - валидация проходит
                          if (value === '-') return true;

                          // Если поле пустое - ошибка
                          if (!value || value.trim() === '') {
                            return "Введите ссылку на WhatsApp или отметьте чекбокс";
                          }

                          // Проверяем корректность ссылки
                          const pattern = /^https:\/\/wa\.me\/\d{8,15}$/;
                          return (
                            pattern.test(value) ||
                            "Некорректная ссылка. Формат: https://wa.me/79991234567"
                          );
                        }
                      })}
                    />
                    {errors.whatsapp?.message && (
                      <Typography variant="caption" color="error">
                        {`${errors.whatsapp?.message}`}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
                <Stack direction="row" spacing={2} sx={{ justifyContent: 'end' }} mt={3}>
                  <Button type='submit' variant="contained" color="primary" size="large" disabled={loadUpdateData}>
                    {loadUpdateData && 'Загрузка...'}
                    {!loadUpdateData && 'Сохранить изменения'}
                  </Button>
                </Stack>
              </form>
            </CardContent>
          </BlankCard>
        </Grid>
      </Grid>
    </>
  );
};

export default AccountTab;